// src/pages/Home.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { motion } from 'framer-motion';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import HomeHero from './HomeHero';

// === IMAGES ===
import sigiriya from '../assets/pick2/sigiriya/istockphoto-1492229422-612x612.jpg';
import udawalawa from '../assets/pick2/udawalawe/istockphoto-904632224-612x612.jpg';
import ella from '../assets/pick2/Ella/pexels-iakub-arifulin-205356454-11675420.jpg';
import mirissa from '../assets/pick2/Mirissa/pexels-ollivves-1005417.jpg';
import nuwaraeliya from '../assets/Aamy/28.jpg';
import kandy from '../assets/pick2/kandy/pexels-gihan-bandara-142954990-20836060.jpg';
import galle from '../assets/pick2/Galle/pexels-shainee-2933943.jpg';
import Yala from '../assets/pick2/yala/pexels-leefinvrede-18463828.jpg';
import anuradhapura from '../assets/pick2/Anuradapura/istockphoto-1178654295-612x612.jpg';
import polonnaruwa from '../assets/pick2/polonnaruwa/istockphoto-510311016-612x612.jpg';

import excursionImage from '../assets/Sonic New/36.jpeg';
import esalaPeraharaImage from '../assets/pick/35.jpg';
import safariImage from '../assets/pick/37.jpg';
import elephantRideFeatureImage from '../assets/ElephantRide/elephant-back-riding.jpg';
import label1 from '../assets/pick/36.jpg';
import label2 from '../assets/pick2/yala/LK710A2062-02-E.webp';

import package1 from '../assets/pick/38.jpg';
import package2 from '../assets/pick2/Ella/pexels-iakub-arifulin-205356454-11675420.jpg';
import package3 from '../assets/pick2/Anuradapura/istockphoto-1178654295-612x612.jpg';
import package4 from '../assets/pick2/yala/istockphoto-579436668-612x612.jpg';
import package5 from '../assets/pick2/Galle/istockphoto-472387838-612x612.jpg';
import package6 from '../assets/pick2/colombo/istockphoto-1181382649-612x612.jpg';

import aboutContactImage from '../assets/Sonic/40.jpeg';

// Famous Tours Images
import benthotaImage from '../assets/Sonic/59.jpeg';
import polgampalaImage from '../assets/Sonic/8.jpeg';
import galleToursImage from '../assets/Sonic/33.jpeg';
import sigiriyaToursImage from '../assets/Sonic/41.jpeg';
import mirissakImage from '../assets/Sonic New/30.jpeg';
import turtleFarmImage from '../assets/Sonic/60.jpeg';
import templeVisitImage from '../assets/Sonic/34.jpeg';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Gallery Images
import gallery1 from '../assets/Sonic/76.jpeg';
import gallery2 from '../assets/Sonic/72].jpeg';
import gallery3 from '../assets/Sonic/78.jpeg';
import gallery4 from '../assets/Sonic/62.jpeg';
import gallery5 from '../assets/Sonic/63.jpeg';
import gallery6 from '../assets/Sonic/80.jpeg';
import gallery7 from '../assets/Sonic/84.jpeg';
import gallery8 from '../assets/Sonic/87.jpeg';
import gallery9 from '../assets/Sonic/73.jpeg';
import gallery10 from '../assets/Sonic/47.jpeg';
import gallery11 from '../assets/Sonic/40.jpeg';
import gallery12 from '../assets/Sonic/35.jpeg';
import gallery13 from '../assets/Sonic/26.jpeg';
import gallery14 from '../assets/Sonic/25.jpeg';
import gallery15 from '../assets/Sonic/28.jpeg';
import gallery16 from '../assets/Sonic/68.jpeg';
import gallery17 from '../assets/Sonic/74.jpeg';
import gallery18 from '../assets/Sonic/86.jpeg';
import gallery19 from '../assets/Sonic/75.jpeg';
import gallery20 from '../assets/Sonic/66.jpeg';
import gallery21 from '../assets/Sonic New/2.jpeg';
import gallery22 from '../assets/Sonic New/17.jpeg';
import gallery23 from '../assets/Sonic New/25.jpeg';
import gallery24 from '../assets/Sonic New/34.jpeg';
import gallery25 from '../assets/Sonic New/32.jpeg';
import gallery26 from '../assets/Sonic New/28.jpeg';
import gallery27 from '../assets/Sonic New/15.jpeg';
import gallery28 from '../assets/Sonic New/16.jpeg';
import gallery29 from '../assets/Sonic New/35.jpeg';
import gallery30 from '../assets/Sonic New/33.jpeg';
import gallery31 from '../assets/Sonic/11.jpeg';

// === MOTION VARIANTS ===
const sectionVariants = { hidden: { opacity: 0, y: 60, scale: 0.94 }, visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.9, ease: "easeOut" } } };
const textVariants = { hidden: { opacity: 0, y: 25 }, visible: { opacity: 1, y: 0, transition: { duration: 0.7 } } };
const scaleUp = { hidden: { opacity: 0, scale: 0.88 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.8 } } };
const staggerContainer = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.18 } } };
const accordionItem = { hidden: { opacity: 0, y: 12 }, show: { opacity: 1, y: 0, transition: { duration: 0.45 } } };

// === SLICK SETTINGS ===
const galleryMobileSettings = {
    dots: false, infinite: true, speed: 500, slidesToShow: 1, slidesToScroll: 1,
    autoplay: true, autoplaySpeed: 3000, arrows: false,

    customPaging: () => (<div className="w-2 h-2 rounded-full bg-white/30 mx-1 transition-all duration-300 hover:bg-[#7FDBFF]" />)
};

const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
};
const cardHover = {
    rest: { scale: 1, y: 0 },
    hover: { scale: 1.04, y: -12, transition: { duration: 0.4 } }
};


// === TITLE COMPONENT ===
const SectionTitle = ({ mainTitle, subTitle }) => (
    <div className="flex flex-col items-center text-center">
        <h2 className="font-konkhmer text-[2.5rem] uppercase md:text-4xl lg:text-5xl xl:text-6xl text-[#7FDBFF]">

            {mainTitle}

        </h2>
        <p className="mt-2 font-inknut text-sm text-white/70 md:text-base lg:mt-3 lg:text-lg">{subTitle}</p>
        <div className="mt-3 flex w-full max-w-md gap-2">
            <div className="h-[3px] flex-1" style={{ background: '#0074D9', boxShadow: '0 0 6px #0074D9' }}></div>
            <div className="h-[3px] flex-1" style={{ background: '#7FDBFF', boxShadow: '0 0 6px #7FDBFF' }}></div>
        </div>
    </div>
);

const Home = () => {
    const { t } = useTranslation('home');

    const [activeIndex, setActiveIndex] = useState(null);
    const [activePackage, setActivePackage] = useState(0);
    const [isMd, setIsMd] = useState(false);

    const toggleService = (index) => setActiveIndex(activeIndex === index ? null : index);
    const nextSlide = () => setActivePackage((prev) => (prev + 1) % 6);
    const prevSlide = () => setActivePackage((prev) => (prev - 1 + 6) % 6);
    const slideDistance = isMd ? 180 : 340;

    // Responsive check for slider spacing
    useEffect(() => {
        const handleResize = () => setIsMd(window.innerWidth >= 768 && window.innerWidth <= 1024);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Load Elfsight widget
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://elfsightcdn.com/platform.js';
        script.async = true;
        document.body.appendChild(script);
        return () => { if (document.body.contains(script)) document.body.removeChild(script); };
    }, []);

    // === TRANSLATED DATA ===
    const destinations = [
        { label: t('recommendations.sigiriya.label'), name: t('recommendations.sigiriya.name'), image: sigiriya },
        { label: t('recommendations.udawalawa.label'), name: t('recommendations.udawalawa.name'), image: udawalawa },
        { label: t('recommendations.ella.label'), name: t('recommendations.ella.name'), image: ella },
        { label: t('recommendations.mirissa.label'), name: t('recommendations.mirissa.name'), image: mirissa },
        { label: t('recommendations.nuwaraeliya.label'), name: t('recommendations.nuwaraeliya.name'), image: nuwaraeliya },
        { label: t('recommendations.kandy.label'), name: t('recommendations.kandy.name'), image: kandy },
        { label: t('recommendations.galle.label'), name: t('recommendations.galle.name'), image: galle },
        { label: t('recommendations.yala.label'), name: t('recommendations.yala.name'), image: Yala },
        { label: t('recommendations.anuradhapura.label'), name: t('recommendations.anuradhapura.name'), image: anuradhapura },
        { label: t('recommendations.polonnaruwa.label'), name: t('recommendations.polonnaruwa.name'), image: polonnaruwa },
    ];

    const excursions = [
        { title: t('excursions.oneDay.title'), des: t('excursions.oneDay.des') },
        { title: t('excursions.twoDays.title'), des: t('excursions.twoDays.des') },
        { title: t('excursions.threeDays.title'), des: t('excursions.threeDays.des') },
        { title: t('excursions.fourDays.title'), des: t('excursions.fourDays.des') },
        { title: t('excursions.fiveDays.title'), des: t('excursions.fiveDays.des') },
        { title: t('excursions.sixDays.title'), des: t('excursions.sixDays.des') },
    ];

    const packages = [
        { id: 1, image: package1, title: t('packages.one.title'), duration: t('packages.one.duration'), description: t('packages.one.desc') },
        { id: 2, image: package2, title: t('packages.two.title'), duration: t('packages.two.duration'), description: t('packages.two.desc') },
        { id: 3, image: package3, title: t('packages.three.title'), duration: t('packages.three.duration'), description: t('packages.three.desc') },
        { id: 4, image: package4, title: t('packages.four.title'), duration: t('packages.four.duration'), description: t('packages.four.desc') },
        { id: 5, image: package5, title: t('packages.five.title'), duration: t('packages.five.duration'), description: t('packages.five.desc') },
        { id: 6, image: package6, title: t('packages.six.title'), duration: t('packages.six.duration'), description: t('packages.six.desc') },
    ];

    const featuredExperiences = [
        {
            h2: t('featured.elephantRide.h2'),
            h3: t('featured.elephantRide.h3'),
            paragraph: t('featured.elephantRide.paragraph'),
            image: elephantRideFeatureImage,
            label: null,
            buttonText: t('featured.elephantRide.button'),
            link: '/elephant-ride',
            buttonGradient: 'linear-gradient(to right, #7FDBFF, #40c4e6)'
        },
        {
            h2: t('featured.perahera.h2'),
            h3: t('featured.perahera.h3'),
            h4: t('featured.perahera.h4'),
            paragraph: t('featured.perahera.paragraph'),
            image: esalaPeraharaImage,
            label: label1,
            buttonText: t('featured.perahera.button'),
            link: '/events',
            buttonGradient: 'linear-gradient(to right, #0074D9, #005fae)'
        },
        {
            h2: t('featured.safari.h2'),
            h3: t('featured.safari.h3'),
            paragraph: t('featured.safari.paragraph'),
            image: safariImage,
            label: label2,
            buttonText: t('featured.safari.button'),
            link: '/gallery',
            buttonGradient: 'linear-gradient(to right, #7FDBFF, #40c4e6)'
        },
    ];

    const galleryImages = [
        { src: gallery1, alt: t('gallery.alt1') }, { src: gallery2, alt: t('gallery.alt2') }, { src: gallery3, alt: t('gallery.alt3') },
        { src: gallery4, alt: t('gallery.alt4') }, { src: gallery5, alt: t('gallery.alt5') }, { src: gallery6, alt: t('gallery.alt6') },
        { src: gallery7, alt: t('gallery.alt7') }, { src: gallery8, alt: t('gallery.alt8') }, { src: gallery9, alt: t('gallery.alt9') },
        { src: gallery10, alt: t('gallery.alt10') }, { src: gallery11, alt: t('gallery.alt11') }, { src: gallery12, alt: t('gallery.alt12') },
        { src: gallery13, alt: t('gallery.alt13') }, { src: gallery14, alt: t('gallery.alt14') }, { src: gallery15, alt: t('gallery.alt15') },
        { src: gallery16, alt: t('gallery.alt16') }, { src: gallery17, alt: t('gallery.alt17') }, { src: gallery18, alt: t('gallery.alt18') },
        { src: gallery19, alt: t('gallery.alt19') }, { src: gallery20, alt: t('gallery.alt20') }, { src: gallery21, alt: t('gallery.alt21') },
        { src: gallery22, alt: t('gallery.alt22') }, { src: gallery23, alt: t('gallery.alt23') }, { src: gallery24, alt: t('gallery.alt24') },
        { src: gallery25, alt: t('gallery.alt25') }, { src: gallery26, alt: t('gallery.alt26') }, { src: gallery27, alt: t('gallery.alt27') },
        { src: gallery28, alt: t('gallery.alt28') }, { src: gallery29, alt: t('gallery.alt29') }, { src: gallery30, alt: t('gallery.alt30') },
        { src: gallery31, alt: t('gallery.alt31') },
    ];

    return (
        <div className="bg-[#001F3F] min-h-screen text-white">
            {/* HERO */}
            <HomeHero />

            {/* CURATED DESTINATIONS */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                className="py-16 md:py-24"
            >
                <div className="container mx-auto px-5 md:px-8 lg:px-12">
                    <SectionTitle
                        mainTitle={t('sections.recommendations.title')}
                        subTitle={t('sections.recommendations.subtitle')}
                    />

                    <Swiper
                        modules={[Navigation, Autoplay, Pagination]}
                        spaceBetween={20}
                        slidesPerView={1.1}
                        centeredSlides={true}
                        loop={true}
                        autoplay={{ delay: 4500, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                        navigation={true}
                        breakpoints={{
                            640: { slidesPerView: 2, centeredSlides: false },
                            768: { slidesPerView: 2.5 },
                            1024: { slidesPerView: 3.5 },
                            1280: { slidesPerView: 4.2 },
                        }}
                        className="pb-12 !px-4 mt-10"
                    >
                        {destinations.map((dest, idx) => (
                            <SwiperSlide key={idx}>
                                <motion.div
                                    variants={cardHover}
                                    initial="rest"
                                    whileHover="hover"
                                    className="group relative h-[460px] md:h-[520px] rounded-2xl overflow-hidden shadow-2xl cursor-pointer"
                                >
                                    <img
                                        src={dest.image}
                                        alt={dest.name}
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent opacity-70 group-hover:opacity-90 transition-opacity" />
                                    <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                                        <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-white drop-shadow-lg">
                                            {dest.label}
                                        </h3>
                                        <p className="mt-2 text-lg md:text-xl text-white/90 font-medium drop-shadow">
                                            {dest.name}
                                        </p>
                                    </div>
                                </motion.div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </motion.section>

            {/* TRIPADVISOR REVIEWS */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                className="py-16 md:py-24 bg-gradient-to-b from-[#001F3F] to-[#000C1F]"
            >
                <div className="container mx-auto px-5 md:px-8 lg:px-12">
                    <motion.div variants={textVariants} className="text-center mb-12">
                        <motion.div className="flex items-center justify-center gap-6 mb-6">
                            <div className="h-px w-[50px] bg-gradient-to-r from-[#0074D9] to-transparent"></div>
                            <h2 className="font-konkhmer text-4xl md:text-5xl lg:text-6xl font-bold uppercase text-[#7FDBFF]">
                                What Our Guests Say
                            </h2>
                            <div className="h-px w-[50px] bg-gradient-to-l from-[#0074D9] to-transparent"></div>
                        </motion.div>
                        <motion.p variants={textVariants} className="mt-4 text-white/70 text-base md:text-lg max-w-2xl mx-auto">
                            Read authentic reviews from travelers who experienced Sonic Tours
                        </motion.p>
                        <motion.div variants={textVariants} className="mt-6 flex justify-center gap-3">
                            <div className="h-1.5 w-12 bg-[#7FDBFF] rounded-full"></div>
                            <div className="h-1.5 w-12 bg-[#0074D9] rounded-full"></div>
                            <div className="h-1.5 w-12 bg-[#7FDBFF] rounded-full"></div>
                        </motion.div>
                    </motion.div>

                    <motion.div
                        variants={textVariants}
                        className="max-w-4xl mx-auto bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-xl border border-[#0074D9]/30 p-6 md:p-8"
                    >
                        <div id="TA_selfserveprop161" className="TA_selfserveprop">
                            <ul id="q55kwOgV" className="TA_links 0sA4uBXVM">
                                <li id="t8sahxt7EE" className="x949OYhLOI">
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.tripadvisor.com/Attraction_Review-g1189172-d34217326-Reviews-Sonic_Tours_Beruwala-Beruwala_Western_Province.html">
                                        <img src="https://www.tripadvisor.com/img/cdsi/img2/branding/v2/Tripadvisor_lockup_horizontal_secondary_registered-11900-2.svg" alt="TripAdvisor" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <script async src="https://www.jscache.com/wejs?wtype=selfserveprop&amp;uniq=161&amp;locationId=34217326&amp;lang=en_US&amp;rating=true&amp;nreviews=5&amp;writereviewlink=true&amp;popIdx=true&amp;iswide=false&amp;border=true&amp;display_version=2" data-loadtrk onload="this.loadtrk=true"></script>
                    </motion.div>
                </div>
            </motion.section>

            {/* TOUR PROGRAMMES */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="">
                <div className="container mx-auto px-4 font-redHatDisplay">
                    <motion.div variants={textVariants} className="flex items-center gap-6">
                        <div className="h-px w-[50px] bg-gradient-to-r from-[#0074D9] to-transparent"></div>
                        <h1 className="text-[18px] font-bold uppercase md:text-[32px] lg:text-[44px]">{t('sections.excursions.title')}</h1>
                    </motion.div>
                    <motion.div variants={textVariants} className="mt-3 justify-between lg:flex">
                        <p className="w-full text-white/70 lg:w-[50%] lg:text-lg">{t('sections.excursions.desc')}</p>
                        <div className="mt-6 lg:mt-0 lg:flex lg:w-[50%] justify-end">
                            <a href="/tour" className="inline-flex items-center justify-center rounded-full bg-white px-6 py-2.5 text-lg font-bold text-black hover:bg-gray-100 transition">{t('common.viewAll')}</a>
                        </div>
                    </motion.div>
                    <motion.div variants={textVariants} className="my-8 h-px w-full bg-white/10 lg:my-14"></motion.div>
                    <div className="gap-16 lg:flex">
                        <motion.div variants={scaleUp} className="relative mb-12 h-[420px] w-full lg:mb-0 lg:h-[580px] lg:w-[50%] rounded-xl overflow-hidden shadow-2xl">
                            <img src={excursionImage} alt="Journey" className="h-full w-full object-cover" loading="lazy" />
                        </motion.div>
                        <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={{ once: true }} className="space-y-5 lg:w-[60%]">
                            {excursions.map((service, i) => (
                                <motion.div key={i} variants={accordionItem} onClick={() => toggleService(i)} className="cursor-pointer rounded-xl border border-white/10 bg-[#001F3F]/80 p-5 backdrop-blur-sm hover:border-[#0074D9] hover:bg-[#001F3F]/90 transition-all">
                                    <h2 className="flex justify-between items-center text-lg font-bold lg:text-xl">
                                        {service.title}
                                        <span className="text-3xl font-thin text-[#7FDBFF]">{activeIndex === i ? '−' : '+'}</span>
                                    </h2>
                                    {activeIndex === i && <p className="mt-3 text-sm text-white/70 lg:text-base">{service.des}</p>}
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </div>
            </motion.section>

            {/* OUR SIGNIFICANT FAMOUS TOURS */}
            <section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-16 md:py-24 bg-gradient-to-b from-[#001F3F] to-[#000C1F]">
                <div className="container mx-auto px-5 md:px-8 lg:px-12">
                    {/* Section Header */}
                    <motion.div className="text-center mb-16">
                        <motion.div variants={textVariants} className="flex items-center justify-center gap-6 mb-6">
                            <div className="h-px w-[50px] bg-gradient-to-r from-[#0074D9] to-transparent"></div>
                            <h2 className="font-konkhmer text-4xl md:text-5xl lg:text-6xl font-bold uppercase text-[#7FDBFF]">
                                {t('famousTours.title')}
                            </h2>
                            <div className="h-px w-[50px] bg-gradient-to-l from-[#0074D9] to-transparent"></div>
                        </motion.div>
                        <motion.p variants={textVariants} className="mt-4 text-white/70 text-base md:text-lg max-w-2xl mx-auto">
                            {t('famousTours.subtitle')}
                        </motion.p>
                        <motion.div variants={textVariants} className="mt-6 flex justify-center gap-3">
                            <div className="h-1.5 w-12 bg-[#7FDBFF] rounded-full"></div>
                            <div className="h-1.5 w-12 bg-[#0074D9] rounded-full"></div>
                            <div className="h-1.5 w-12 bg-[#7FDBFF] rounded-full"></div>
                        </motion.div>
                    </motion.div>

                    {/* Tours Grid */}
                    <div
                        variants={staggerContainer}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, amount: 0.2 }}
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8"
                    >
                        {/* Benthota River Safari */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400"
                        >
                            <div className="relative h-64 md:h-72 overflow-hidden">
                                <img src={benthotaImage} alt="Benthota" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 group-hover:to-black/80 transition-all duration-500"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-3 group-hover:text-white transition-colors">
                                    {t('famousTours.tours.benthotaRiverSafari.title')}
                                </h3>
                                <div className="h-1 w-12 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mb-4"></div>
                                <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                    {t('famousTours.tours.benthotaRiverSafari.description')}
                                </p>
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Benthota%20River%20Safari%20tour." target="_blank" rel="noopener noreferrer" className="block mt-6">
                                    <button className="w-full rounded-lg bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] py-2.5 font-semibold text-white hover:shadow-lg transition-all group-hover:scale-105 cursor-pointer">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>

                        {/* Polgampala Water Pool Tour */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400"
                        >
                            <div className="relative h-64 md:h-72 overflow-hidden">
                                <img src={polgampalaImage} alt="Polgampala" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 group-hover:to-black/80 transition-all duration-500"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-3 group-hover:text-white transition-colors">
                                    {t('famousTours.tours.polgampalaWaterPool.title')}
                                </h3>
                                <div className="h-1 w-12 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mb-4"></div>
                                <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                    {t('famousTours.tours.polgampalaWaterPool.description')}
                                </p>
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Polgampala%20Water%20Pool%20tour." target="_blank" rel="noopener noreferrer" className="block mt-6">
                                    <button className="w-full rounded-lg bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] py-2.5 font-semibold text-white hover:shadow-lg transition-all group-hover:scale-105 cursor-pointer">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>

                        {/* Galle Tour */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400"
                        >
                            <div className="relative h-64 md:h-72 overflow-hidden">
                                <img src={galleToursImage} alt="Galle" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 group-hover:to-black/80 transition-all duration-500"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-3 group-hover:text-white transition-colors">
                                    {t('famousTours.tours.galleTour.title')}
                                </h3>
                                <div className="h-1 w-12 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mb-4"></div>
                                <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                    {t('famousTours.tours.galleTour.description')}
                                </p>
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Galle%20tour." target="_blank" rel="noopener noreferrer" className="block mt-6">
                                    <button className="w-full rounded-lg bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] py-2.5 font-semibold text-white hover:shadow-lg transition-all group-hover:scale-105 cursor-pointer">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>

                        {/* Sigiriya Tour */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400"
                        >
                            <div className="relative h-64 md:h-72 overflow-hidden">
                                <img src={sigiriyaToursImage} alt="Sigiriya" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 group-hover:to-black/80 transition-all duration-500"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-3 group-hover:text-white transition-colors">
                                    {t('famousTours.tours.sigiriyaTour.title')}
                                </h3>
                                <div className="h-1 w-12 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mb-4"></div>
                                <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                    {t('famousTours.tours.sigiriyaTour.description')}
                                </p>
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Sigiriya%20tour." target="_blank" rel="noopener noreferrer" className="block mt-6">
                                    <button className="w-full rounded-lg bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] py-2.5 font-semibold text-white hover:shadow-lg transition-all group-hover:scale-105 cursor-pointer">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>

                        {/* Mirissa Beach */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400"
                        >
                            <div className="relative h-64 md:h-72 overflow-hidden">
                                <img src={mirissakImage} alt="Mirissa" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 group-hover:to-black/80 transition-all duration-500"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-3 group-hover:text-white transition-colors">
                                    {t('famousTours.tours.mirissaBeach.title')}
                                </h3>
                                <div className="h-1 w-12 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mb-4"></div>
                                <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                    {t('famousTours.tours.mirissaBeach.description')}
                                </p>
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Mirissa%20Beach%20tour." target="_blank" rel="noopener noreferrer" className="block mt-6">
                                    <button className="w-full rounded-lg bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] py-2.5 font-semibold text-white hover:shadow-lg transition-all group-hover:scale-105 cursor-pointer">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>

                        {/* Turtle Farm Visit */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400"
                        >
                            <div className="relative h-64 md:h-72 overflow-hidden">
                                <img src={turtleFarmImage} alt="Turtle Farm" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 group-hover:to-black/80 transition-all duration-500"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-3 group-hover:text-white transition-colors">
                                    {t('famousTours.tours.turtleFarmVisit.title')}
                                </h3>
                                <div className="h-1 w-12 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mb-4"></div>
                                <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                    {t('famousTours.tours.turtleFarmVisit.description')}
                                </p>
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Turtle%20Farm%20Visit%20tour." target="_blank" rel="noopener noreferrer" className="block mt-6">
                                    <button className="w-full rounded-lg bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] py-2.5 font-semibold text-white hover:shadow-lg transition-all group-hover:scale-105 cursor-pointer">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>

                        {/* Temple Visit */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative bg-gradient-to-br from-[#002b55] to-[#00162f] rounded-2xl overflow-hidden shadow-xl border border-[#0074D9]/30 hover:border-[#7FDBFF]/60 transition-all duration-400"
                        >
                            <div className="relative h-64 md:h-72 overflow-hidden">
                                <img src={templeVisitImage} alt="Temple Visit" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 group-hover:to-black/80 transition-all duration-500"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="text-[#7FDBFF] text-xl md:text-2xl font-bold mb-3 group-hover:text-white transition-colors">
                                    {t('famousTours.tours.templeVisit.title')}
                                </h3>
                                <div className="h-1 w-12 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mb-4"></div>
                                <p className="text-white/80 text-sm md:text-base leading-relaxed">
                                    {t('famousTours.tours.templeVisit.description')}
                                </p>
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Temple%20Visit%20tour." target="_blank" rel="noopener noreferrer" className="block mt-6">
                                    <button className="w-full rounded-lg bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] py-2.5 font-semibold text-white hover:shadow-lg transition-all group-hover:scale-105 cursor-pointer">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* FEATURED EXPERIENCES */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-20">
                <div className="container mx-auto px-4">
                    {/* Mobile */}
                    <div className="block space-y-24 sm:hidden">
                        {featuredExperiences.map((exp) => (
                            <div key={exp.h3} className="text-center">
                                <h2 className="font-redHatDisplay text-xl font-semibold uppercase text-[#0074D9]">{exp.h2}</h2>
                                <h3 className="font-redHatDisplay text-3xl font-bold uppercase text-white">{exp.h3}</h3>
                                {exp.h4 && <h4 className="font-redHatDisplay text-base font-medium text-[#7FDBFF]">{exp.h4}</h4>}
                                <div className="relative mt-8 h-[520px] w-full rounded-[32px] border-[4px] border-white/10 overflow-hidden shadow-2xl">
                                    <img src={exp.image} alt={exp.h3} className="h-full w-full object-cover" loading="lazy" />
                                    {exp.label && <img src={exp.label} alt="" className="absolute -bottom-2 left-1/2 -translate-x-1/2 h-[130px] w-auto" />}
                                </div>
                                <p className="mt-8 px-4 text-sm leading-7 text-white/85" dangerouslySetInnerHTML={{ __html: exp.paragraph }} />

                            </div>
                        ))}
                    </div>

                    {/* Desktop */}
                    <div className="hidden sm:block space-y-20">
                        {/* Elephant Ride */}
                        <div className="flex flex-col-reverse md:flex-row items-center justify-between">
                            <div className="relative mt-10 md:mt-0 md:w-[520px] lg:w-[700px]">
                                <img src={featuredExperiences[0].image} alt={featuredExperiences[0].h3} className="w-full rounded-[32px] border-[4px] border-white/10 shadow-2xl" loading="lazy" />
                            </div>
                            <div className="md:w-[50%] text-center md:text-right">
                                <h2 className="font-redHatDisplay text-3xl font-semibold uppercase text-[#0074D9]">{featuredExperiences[0].h2}</h2>
                                <h3 className="font-redHatDisplay text-5xl font-bold uppercase text-white">{featuredExperiences[0].h3}</h3>
                                <p className="mt-6 text-lg text-white/85" dangerouslySetInnerHTML={{ __html: featuredExperiences[0].paragraph }} />

                            </div>
                        </div>

                        {/* Perahera */}
                        <div className="flex flex-col md:flex-row items-center justify-between">
                            <div className="md:w-[50%] text-center md:text-left">
                                <h2 className="font-redHatDisplay text-3xl font-semibold uppercase text-[#0074D9]">{featuredExperiences[1].h2}</h2>
                                <h3 className="font-redHatDisplay text-5xl font-bold uppercase text-white">{featuredExperiences[1].h3}</h3>
                                <h4 className="font-redHatDisplay text-2xl font-medium text-[#7FDBFF]">{featuredExperiences[1].h4}</h4>
                                <p className="mt-6 text-lg text-white/85" dangerouslySetInnerHTML={{ __html: featuredExperiences[1].paragraph }} />

                            </div>
                            <div className="relative mt-10 md:mt-0 md:w-[520px] lg:w-[700px]">
                                <img src={featuredExperiences[1].image} alt={featuredExperiences[1].h3} className="w-full rounded-[32px] border-[4px] border-white/10 shadow-2xl" loading="lazy" />
                                {featuredExperiences[1].label && <img src={featuredExperiences[1].label} alt="" className="absolute -bottom-10 left-0 hidden md:block h-[220px]" />}
                            </div>
                        </div>

                        {/* Safari */}
                        <div className="flex flex-col-reverse md:flex-row items-center justify-between">
                            <div className="relative mt-10 md:mt-0 md:w-[520px] lg:w-[700px]">
                                <img src={featuredExperiences[2].image} alt={featuredExperiences[2].h3} className="w-full rounded-[32px] border-[4px] border-white/10 shadow-2xl" loading="lazy" />
                                {featuredExperiences[2].label && <img src={featuredExperiences[2].label} alt="" className="absolute -bottom-10 right-0 hidden md:block h-[220px]" />}
                            </div>
                            <div className="md:w-[50%] text-center md:text-right">
                                <h2 className="font-redHatDisplay text-3xl font-semibold uppercase text-[#0074D9]">{featuredExperiences[2].h2}</h2>
                                <h3 className="font-redHatDisplay text-5xl font-bold uppercase text-white">{featuredExperiences[2].h3}</h3>
                                <p className="mt-6 text-lg text-white/85" dangerouslySetInnerHTML={{ __html: featuredExperiences[2].paragraph }} />

                            </div>
                        </div>
                    </div>
                </div>
            </motion.section>

            {/* EXCLUSIVE PACKAGES SLIDER */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-10 ">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-10">
                        <h2 className="font-konkhmer text-4xl md:text-5xl lg:text-6xl font-bold uppercase text-[#7FDBFF] mb-4">
                            {t('sections.packages.title')}
                        </h2>
                        <div className="flex justify-center gap-3 mt-6">
                            <div className="h-1 w-16 bg-[#0074D9] rounded-full"></div>
                            <div className="h-1 w-16 bg-[#7FDBFF] rounded-full"></div>
                        </div>
                    </div>

                    {/* Mobile/Tablet Slider */}
                    <div className="lg:hidden">
                        <div className="relative flex h-[620px] md:h-[740px] items-center justify-center overflow-hidden">
                            {/* Left Arrow */}
                            <button
                                onClick={prevSlide}
                                className="absolute left-5 z-40 rounded-full border-2 border-white/30 bg-black/40 p-3 backdrop-blur-md hover:bg-white/20 transition-all duration-200"
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M15 18l-6-6 6-6" />
                                </svg>
                            </button>

                            {/* Right Arrow */}
                            <button
                                onClick={nextSlide}
                                className="absolute right-5 z-40 rounded-full border-2 border-white/30 bg-black/40 p-3 backdrop-blur-md hover:bg-white/20 transition-all duration-200"
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M9 6l6 6-6 6" />
                                </svg>
                            </button>

                            {packages.map((pkg, i) => {
                                const total = packages.length;
                                const normalizedIndex = ((i - activePackage + total) % total);

                                let position = '';
                                let scale = 1;
                                let opacity = 0;
                                let zIndex = 0;
                                let showDetails = false;
                                let showSideImage = false;

                                if (normalizedIndex === 0) {
                                    position = 'translateX(0)';
                                    scale = 1;
                                    opacity = 1;
                                    zIndex = 30;
                                    showDetails = true;
                                }
                                else if (normalizedIndex === 1) {
                                    position = `translateX(${slideDistance}px)`;
                                    opacity = 0.8;
                                    zIndex = 20;
                                    showSideImage = true;
                                }
                                else if (normalizedIndex === total - 1) {
                                    position = `translateX(-${slideDistance}px)`;
                                    opacity = 0.8;
                                    zIndex = 20;
                                    showSideImage = true;
                                }
                                else {
                                    opacity = 0;
                                }

                                return (
                                    <div
                                        key={pkg.id}
                                        className="absolute transition-all duration-700 ease-in-out"
                                        style={{
                                            transform: `${position} scale(${scale})`,
                                            zIndex,
                                            opacity,
                                        }}
                                    >
                                        {showDetails ? (
                                            <div className="w-[270px] md:w-[440px]">
                                                <div className="overflow-hidden rounded-[28px] border border-[#0074D9]/40 bg-gradient-to-br from-[#001F3F]/90 via-[#00162F]/85 to-[#000F1F]/90 p-6 md:p-8 text-center backdrop-blur-xl shadow-2xl hover:border-[#7FDBFF]/60 transition-all duration-500">
                                                    <div className="relative mb-6 overflow-hidden rounded-[20px]">
                                                        <img src={pkg.image} alt={pkg.title} className="w-full h-[160px] md:h-[280px] object-cover" loading="lazy" />
                                                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                                                    </div>
                                                    <h3 className="font-redHatDisplay text-lg md:text-xl font-bold uppercase text-white">{pkg.title}</h3>
                                                    <p className="text-[#7FDBFF] text-base md:text-lg font-bold mt-2">({pkg.duration})</p>
                                                    <p className="mt-4 text-xs md:text-sm text-white/75 line-clamp-2">{pkg.description}</p>
                                                </div>
                                                <a href="/tour" className="block mt-6">
                                                    <button className="w-full rounded-full bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] py-3.5 font-bold text-white hover:shadow-xl hover:scale-105 transition-all duration-300 shadow-lg">
                                                        Reserve Now
                                                    </button>
                                                </a>
                                            </div>
                                        ) : showSideImage ? (
                                            <div className="hidden md:block w-[210px] md:w-[340px] overflow-hidden rounded-[20px]">
                                                <img src={pkg.image} alt={pkg.title} className="w-full h-[210px] md:h-[280px] object-cover rounded-[20px]" loading="lazy" />
                                            </div>
                                        ) : null}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Desktop Grid Layout */}
                    <div className="hidden lg:block">
                        <div className="grid grid-cols-3 gap-8 xl:gap-10">
                            {packages.map((pkg) => (
                                <motion.div
                                    key={pkg.id}
                                    variants={cardHover}
                                    initial="rest"
                                    whileHover="hover"
                                    className="group flex flex-col"
                                >
                                    <div className="relative overflow-hidden rounded-[28px] border border-[#0074D9]/30 bg-gradient-to-br from-[#001F3F]/95 via-[#00162F]/90 to-[#000F1F]/95 backdrop-blur-xl shadow-2xl hover:border-[#7FDBFF]/60 transition-all duration-500 flex-1 flex flex-col p-0">
                                        {/* Image Container */}
                                        <div className="relative h-[300px] overflow-hidden rounded-t-[28px]">
                                            <img
                                                src={pkg.image}
                                                alt={pkg.title}
                                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                                loading="lazy"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/40 group-hover:to-black/60 transition-all duration-300"></div>
                                            <div className="absolute top-4 right-4 bg-[#0074D9] text-white px-4 py-2 rounded-full text-sm font-bold backdrop-blur-md">
                                                {pkg.duration}
                                            </div>
                                        </div>

                                        {/* Content Container */}
                                        <div className="p-7 lg:p-8 flex flex-col flex-1 justify-between">
                                            <div>
                                                <h3 className="font-redHatDisplay text-xl lg:text-2xl font-bold uppercase text-white group-hover:text-[#7FDBFF] transition-colors duration-300">
                                                    {pkg.title}
                                                </h3>
                                                <div className="h-1 w-12 bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] rounded-full mt-3 group-hover:w-20 transition-all duration-300"></div>
                                                <p className="mt-5 text-sm text-white/80 leading-relaxed">
                                                    {pkg.description}
                                                </p>
                                            </div>

                                            <a href="/tour" className="mt-8 block">
                                                <button className="w-full rounded-full bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] py-4 font-bold text-white text-base hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 shadow-lg hover:from-[#005fae] hover:to-[#40c4e6]">
                                                    Reserve Now
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </motion.section>

            {/* GUEST COMMENTS */}
            {/* <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-4">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="font-konkhmer text-5xl font-bold uppercase text-[#7FDBFF]">{t('sections.reviews.title')}</h2>
                    <p className="mt-4 text-white/70">{t('sections.reviews.subtitle')}</p>
                    <div className="mt-8 flex justify-center gap-2"><div className="h-[3px] w-32 bg-[#0074D9] shadow-glow"></div><div className="h-[3px] w-32 bg-[#7FDBFF] shadow-glow"></div></div>
                    <div className="mt-14 flex justify-center">
                        <div className="elfsight-app-c71ea6ad-b325-4591-85b7-44592acd03e5 w-full max-w-5xl" data-elfsight-app-lazy style={{ minHeight: '420px' }}></div>
                    </div>
                </div>
            </motion.section> */}

            {/* OUR GALLERY SECTION */}
            <section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={sectionVariants}
                className="py-10 bg-gradient-to-b from-[#001F3F] via-[#001B36] to-[#001F3F]"
            >
                <div className="container mx-auto px-4">
                    {/* Header */}
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="flex items-center gap-5"
                    >
                        <div className="h-px w-[40px] bg-gradient-to-r from-[#0074D9] to-transparent"></div>
                        <h1 className="text-[25px] font-bold uppercase font-konkhmer md:text-[30px] lg:text-[40px] text-[#7FDBFF]">

                            {t('gallery.title')}

                        </h1>
                    </motion.div>

                    <motion.p
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="mt-2 w-full font-medium text-white/70 lg:w-[50%] lg:text-lg font-inknut"
                    >
                        {t('gallery.subtitle')}
                    </motion.p>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="my-8 h-px w-full bg-gradient-to-r from-transparent via-white/20 to-transparent lg:my-14"
                    />

                    {/* Mobile Carousel */}
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="mt-5 block md:hidden"
                    >
                        <Slider {...galleryMobileSettings}>
                            {galleryImages.map((image, index) => (
                                <div key={index} className="px-2">
                                    <div className="relative h-[300px] w-full overflow-hidden rounded-lg">
                                        <img
                                            src={image.src}
                                            alt={image.alt}
                                            className="h-full w-full object-cover"
                                            onError={(e) => {
                                                e.target.src = 'https://via.placeholder.com/300x300?text=Image+Not+Found';
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </motion.div>

                    {/* Tablet Grid */}
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="mt-5 hidden md:grid md:grid-cols-2 lg:hidden gap-4"
                    >
                        {galleryImages.map((image, index) => (
                            <div key={index} className="relative h-[250px] w-full overflow-hidden rounded-lg">
                                <img
                                    src={image.src}
                                    alt={image.alt}
                                    className="h-full w-full object-cover"
                                    onError={(e) => {
                                        e.target.src = 'https://via.placeholder.com/250x250?text=Image+Not+Found';
                                    }}
                                />
                            </div>
                        ))}
                    </motion.div>

                    {/* Desktop Gallery Layout - Professional Masonry Grid */}
                    {/* Row 1: Hero Image + 2 Column Stack */}
                    <div className="mt-8 hidden lg:grid lg:grid-cols-12 gap-5">
                        {/* Large Hero Image */}
                        <div className="col-span-8 relative h-[720px] overflow-hidden rounded-2xl shadow-2xl group">
                            <img
                                src={galleryImages[0].src}
                                alt={galleryImages[0].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>

                        {/* Side Column - 2 Stacked Images */}
                        <div className="col-span-4 flex flex-col gap-5">
                            <div className="relative h-[300px] overflow-hidden rounded-2xl shadow-xl group">
                                <img
                                    src={galleryImages[1].src}
                                    alt={galleryImages[1].alt}
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                            <div className="relative h-[400px] overflow-hidden rounded-2xl shadow-xl group">
                                <img
                                    src={galleryImages[2].src}
                                    alt={galleryImages[2].alt}
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                        </div>
                    </div>

                    {/* Row 2: 4 Column Grid */}
                    <div className="mt-5 hidden lg:grid lg:grid-cols-4 gap-5">
                        <div className="relative h-[300px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[3].src}
                                alt={galleryImages[3].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[300px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[4].src}
                                alt={galleryImages[4].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[300px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[5].src}
                                alt={galleryImages[5].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[300px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[6].src}
                                alt={galleryImages[6].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                    </div>

                    {/* Row 3: 2 Column Stack + Wide Image */}
                    <div className="mt-5 hidden lg:grid lg:grid-cols-12 gap-5">
                        {/* Left Side - Stacked Images */}
                        <div className="col-span-5 flex flex-col gap-5">
                            <div className="relative h-[450px] overflow-hidden rounded-2xl shadow-xl group">
                                <img
                                    src={galleryImages[7].src}
                                    alt={galleryImages[7].alt}
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                            <div className="relative h-[450px] overflow-hidden rounded-2xl shadow-xl group">
                                <img
                                    src={galleryImages[8].src}
                                    alt={galleryImages[8].alt}
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                        </div>

                        {/* Right Side - Wide Image */}
                        <div className="col-span-7 relative h-[920px] overflow-hidden rounded-2xl shadow-2xl group">
                            <img
                                src={galleryImages[9].src}
                                alt={galleryImages[9].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                    </div>

                    {/* Row 4: 3 Column Grid */}
                    <div className="mt-5 hidden lg:grid lg:grid-cols-3 gap-5">
                        <div className="relative h-[450px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[10].src}
                                alt={galleryImages[10].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[450px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[11].src}
                                alt={galleryImages[11].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[450px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[12].src}
                                alt={galleryImages[12].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                    </div>

                    {/* Row 5: Wide Hero + Side Column */}
                    <div className="mt-5 hidden lg:grid lg:grid-cols-12 gap-5">
                        {/* Wide Hero */}
                        <div className="col-span-7 relative h-[950px] overflow-hidden rounded-2xl shadow-2xl group">
                            <img
                                src={galleryImages[13].src}
                                alt={galleryImages[13].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>

                        {/* Right Column - 2 Images */}
                        <div className="col-span-5 flex flex-col gap-5">
                            <div className="relative h-[415px] overflow-hidden rounded-2xl shadow-xl group">
                                <img
                                    src={galleryImages[14].src}
                                    alt={galleryImages[14].alt}
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                            <div className="relative h-[515px] overflow-hidden rounded-2xl shadow-xl group">
                                <img
                                    src={galleryImages[15].src}
                                    alt={galleryImages[15].alt}
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                        </div>
                    </div>

                    {/* Row 6: 2-1-2 Layout (5 Images) */}
                    <div className="mt-5 hidden lg:grid lg:grid-cols-5 gap-5">
                        <div className="relative h-[280px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[16].src}
                                alt={galleryImages[16].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[280px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[17].src}
                                alt={galleryImages[17].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[280px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[18].src}
                                alt={galleryImages[18].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[280px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[19].src}
                                alt={galleryImages[19].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[280px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[20].src}
                                alt={galleryImages[20].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                    </div>

                    {/* Row 7: Large Left + 2 Stacked Right (3 Images) */}
                    <div className="mt-5 hidden lg:grid lg:grid-cols-12 gap-5">
                        {/* Large image on left */}
                        <div className="col-span-8 relative h-[720px] overflow-hidden rounded-2xl shadow-2xl group">
                            <img
                                src={galleryImages[21].src}
                                alt={galleryImages[21].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>

                        {/* Two stacked images on right */}
                        <div className="col-span-4 flex flex-col gap-5">
                            <div className="relative h-[350px] overflow-hidden rounded-2xl shadow-xl group">
                                <img
                                    src={galleryImages[22].src}
                                    alt={galleryImages[22].alt}
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                            <div className="relative h-[350px] overflow-hidden rounded-2xl shadow-xl group">
                                <img
                                    src={galleryImages[23].src}
                                    alt={galleryImages[23].alt}
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                            </div>
                        </div>
                    </div>

                    {/* Row 8: 4 Equal Images */}
                    <div className="mt-5 hidden lg:grid lg:grid-cols-4 gap-5">
                        <div className="relative h-[350px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[24].src}
                                alt={galleryImages[24].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[350px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[25].src}
                                alt={galleryImages[25].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[350px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[26].src}
                                alt={galleryImages[26].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[350px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[27].src}
                                alt={galleryImages[27].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                    </div>

                    {/* Row 9: 3 Equal Images */}
                    <div className="mt-5 hidden lg:grid lg:grid-cols-3 gap-5">
                        <div className="relative h-[400px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[28].src}
                                alt={galleryImages[28].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[400px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[29].src}
                                alt={galleryImages[29].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                        <div className="relative h-[400px] overflow-hidden rounded-2xl shadow-xl group">
                            <img
                                src={galleryImages[30].src}
                                alt={galleryImages[30].alt}
                                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-20">
                <div className="relative h-[65vh] md:h-[75vh] flex items-center justify-center overflow-hidden">
                    <img src={aboutContactImage} alt={t('cta.alt')} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                    <div className="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>
                    <div className="relative z-10 text-center px-5 max-w-6xl">
                        <h1 className="font-konkhmer text-4xl md:text-6xl font-bold text-white">{t('cta.title')}</h1>
                        <p className="mt-6 text-lg text-white/90 max-w-3xl mx-auto">{t('cta.desc')}</p>
                        <a href="/contact-us" className="mt-10 inline-block">
                            <button className="rounded-full bg-gradient-to-r from-[#0074D9] to-[#7FDBFF] px-10 py-5 text-xl font-bold text-white hover:scale-105 transition shadow-2xl">
                                {t('cta.button')}
                            </button>
                        </a>
                    </div>
                </div>
            </motion.section>
        </div >
    );
};

export default Home;